import { render } from "./LatestMag.vue?vue&type=template&id=5ef91a6d&scoped=true"
import script from "./LatestMag.vue?vue&type=script&lang=js"
export * from "./LatestMag.vue?vue&type=script&lang=js"

import "./LatestMag.vue?vue&type=style&index=0&id=5ef91a6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef91a6d"]])

export default __exports__